import { DynamicStandaloneLoader } from '@/components/Loader';
import { DynamicStandaloneSpinnerProps } from '@/components/Spinner';
import { propClassName } from '@/styles/ScrollPageControls';
import type { ClassNameProp, ExtendedStandaloneComponent, ExtendedStandaloneComponentProps } from '@/types/component';
import cn from 'lib/utils/cn';

export interface ScrollPageControlsLoaderProps extends ExtendedStandaloneComponentProps<DynamicStandaloneSpinnerProps> {
  animation?: ClassNameProp;
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

export const ScrollPageControlsLoaderComponent: ExtendedStandaloneComponent<ScrollPageControlsLoaderProps> = ({
  $standalone,
  animation,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const { options, ...standaloneProps } = $standalone ?? {};
  const { className: standaloneClassName, ...standaloneOptions } = options ?? {};

  const animationClassName = propClassName('loader_animation', animation);
  const colorsClassName = propClassName('loader_colors', colors);
  const sizeClassName = propClassName('loader_size', size);
  const variantClassName = propClassName('loader_variant', variant);

  const componentClassName = cn(
    animationClassName,
    colorsClassName,
    sizeClassName,
    variantClassName,
    standaloneClassName,
    className
  );

  return (
    <DynamicStandaloneLoader
      options={{ className: componentClassName, ...standaloneOptions }}
      {...standaloneProps}
      {...props}
    />
  );
};
